var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.store.status.msg != null)?_c('BaseNotification2',{attrs:{"type":_vm.store.status.type,"text":_vm.store.status.msg,"closable":_vm.store.status.closable},on:{"close":function($event){return _vm.borrarNotificacion()}}}):_vm._e(),_c('LoginForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }